export default "<div class=\"dialog-footer\"></div>\r\n";